module.exports = __webpack_public_path__ + "static/kdb-banner-2@2x-403651bb9247b8a182b8aa26928b6a13.webp";